import bannerImg from "@/assets/banner-automation-system.png";

export default function GrowthAutomationBanner() {
  return (
    <section className="px-5 sm:px-8 py-16 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            One System. Every Platform. Fully Automated.
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Our Growth Automation System publishes your content to 30+ networks simultaneously — so you reach new audiences every day without lifting a finger.
          </p>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-2xl border border-amber-900/20">
          <img
            src={bannerImg}
            alt="ClickSendAI Growth Automation System — AI-Powered Promotion across 30+ platforms"
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}
